import React from 'react'
import './Element.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Col } from 'react-bootstrap'
const element = ({ text, icon }) => {
  return (
    <Col md={icon === 'undo' ? 9 : 6} className="element">
      <div className="element__window">
        <FontAwesomeIcon className="element__window__icon" icon={icon} />
        <span className="element__window__text">{text}</span>
      </div>
    </Col>
  )
}

export default element
